
export default "/assets/lock-closed-mini.f8538718.svg"